import { SingleGamePageTags }       from "_common/seo";
import { initialValidations }       from "_common/ssrWrapper";
import { convertToSlug }            from "_common/utils";
import { tabsList }                 from "_common/utils/game";
import GamePage                     from "_components/pages/game";
import { getResults }               from "_components/pages/game/cardListData/container";
import { getPopularStreamingGames } from "_services/api/broadcast";

const results = props => {
	return (
		<>
			<SingleGamePageTags
				endpoint  = { props?.currentPath }
				gameId    = { props?.gameId }
				gameTitle = { props?.search_query }
				seoTags   = { props?.seoTags }
			/>

			<GamePage { ...props } />
		</>
	);
};

const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {

	let activeTab = tabsList[0].apiEndpoint;

	const { slug, tab }    = context.query;
	const [ gameId, name ] = slug;

	if ( tab )
		activeTab = tab;

	// const pageName = context.query.name;

	const gameIds = isNaN ( parseInt ( gameId ) ) ? null : parseInt ( gameId );

	if ( !gameIds ) {
		return {
			notFound: true
		};
	}

	const [ gameDtailsObj ] = await getPopularStreamingGames.bind ( defaultProps ) ( { gameIds } );

	if ( convertToSlug ( gameDtailsObj?.name ) !== name )
		return {
			notFound: true
		};

	const results = await Promise.allSettled (
		[
			getResults.bind ( defaultProps ) ( {
				searchQuery        : name,
				key                : activeTab,
				pageNo             : 1,
				gameId,
				androidPackageName : gameDtailsObj.androidPackageName
			} )
			// getSEOTags.bind ( defaultProps ) ( { pageName } )
		]
	);

	let initialData = [];
	let seoTags;
	let forceLogout = false;

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {

				case 0:
					initialData = result.value;
					break;

				case 1:
					seoTags = result?.value;
					break;
			}
		}

		if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			forceLogout = true;
	} );

	if ( forceLogout )
		return {
			redirect: {
				destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
				permanent   : false
			}
		};

	if ( !defaultProps?.isLoggedIn && initialData?.length )
		context.res.setHeader (
			"Cache-Control",
			"public, s-maxage=90, stale-while-revalidate=120"
		);

	return {
		props: {
			...defaultProps,
			tabs         : tabsList, // tabs are static data in desktop revamp
			initialData  : initialData,
			search_query : name,
			tab          : activeTab,
			gameDetails  : gameDtailsObj,
			gameId       : gameId,
			seoTags      : []// seoTags.seo_tags ? seoTags.seo_tags : []
		}
	};
} );

export { getServerSideProps };

export default results;
